import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add isSensitive to attributes and sensitive property groups to projects
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v10 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v10Projects(prevState.projects);
  }

  return nextState;
};

// added by v10, but removed in v11
export interface ModelConceptAttributeWithIsSensitive
  extends ModelConceptAttribute {
  isSensitive: boolean;
}

const v10Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }
    const attributesByIri: Record<
      string,
      ModelConceptAttributeWithIsSensitive
    > = {};

    Object.entries(project.diagram.model.modelData.attributesByIri).forEach(
      ([iri, attribute]) => {
        attributesByIri[iri] = {
          ...attribute,
          isSensitive: false,
        };
      }
    );

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            attributesByIri,
            sensitivePropertyGroupsByName: {},
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
